import AsyncStorage from "@react-native-community/async-storage";
import React from "react";
import { useEffect,useState } from "react";
import { View, StyleSheet, Text, TouchableOpacity, ImageBackground, Image } from "react-native";
import { TextInput } from "react-native-gesture-handler";
import api from "../config/api_urls";
import style from "./style";

export default function Premi360(RouterData) {
  const punts = 10;

  const [jocs360, setJocs360] = React.useState([]);
  
  useEffect(() => {
    AsyncStorage.getItem("Jocs360").then((jocs360) => {
      if (jocs360) {
        setJocs360(JSON.parse(jocs360));

      }
    });

  }, []);

  const checkFinish = (jocs360) => {
    if(jocs360.length == 5) // HARDCODED 5 GAMES
    {
      AsyncStorage.getItem("finished_games").then((finished_games) => {
        if (finished_games) {
          finished_games = JSON.parse(finished_games);
          finished_games.push({gameId:26});
          AsyncStorage.setItem("finished_games", JSON.stringify(finished_games));
        }else
        {
          AsyncStorage.setItem("finished_games", JSON.stringify([{gameId:26}]));
        }
      })
    }

  }

  return (
    <View style={{ flex: 1,backgroundColor:'#f5f7fa' }}>
      <ImageBackground
          source={
            RouterData.route.params.projecte["FonsPantalla6"]
              ? {
                  uri:
                    api.api_url +
                    RouterData.route.params.projecte["FonsPantalla6"]
                      .url,
                }
              : null
          }
          style={style.imageBackground}
        >
      <View style={{flex:1,justifyContent:'center',alignSelf:'center',alignItems:'center'}}>
       <Image source={{uri:api.api_url + RouterData.route.params.projecte['ImatgePrincipalTextExplicatiu'].url}} style={{width:'40vw',height:'40vh',resizeMode:'contain'}}/>
        {
           jocs360.length != 4 && jocs360.length != 5 ?
          (
            <>
              <Text style={styles.titol}>{RouterData.route.params.recursos.find(e=> e.tipus_recurs == "completed")['text_recurs'+RouterData.route.params.idioma]}</Text>
              <Text style={styles.paragraf}>{RouterData.route.params.recursos.find(e=> e.tipus_recurs == "won")['text_recurs'+RouterData.route.params.idioma]}</Text>  
            </>
          )
          :
          <Text style={[styles.paragraf,{width:'80%',justifyContent:'center',fontSize:'1.5em'}]}>{RouterData.route.params.recursos.find(e=> e.tipus_recurs == "final360")['text_recurs'+RouterData.route.params.idioma]}</Text>
        }

        <TouchableOpacity style={{paddingTop:'5rem'}}
          onPress={() => {
            if(RouterData.route.params.current360 != null){
              if(jocs360 != null)
              {
                // push new item to useState array
                jocs360.push({id:RouterData.route.params.current360.id,score:10});
                AsyncStorage.setItem("Jocs360", JSON.stringify(jocs360));  
                checkFinish(jocs360)
              }else
              {
                AsyncStorage.setItem("Jocs360", JSON.stringify([{id:RouterData.route.params.current360.id,score:10}]));
              }
              RouterData.navigation.navigate('Vista360',RouterData.route.params);
            }else
            {
              RouterData.navigation.navigate('Home',RouterData.route.params);
            }
          }}
        >
          <Image source={{ uri: api.api_url + RouterData.route.params.recursos.find(e=> e.tipus_recurs == "continuar")["imatge_recurs"+RouterData.route.params.idioma].url,}} style={{width:'30vw',height:'10vh',resizeMode:'contain'}}/>
        </TouchableOpacity>

      </View>
      </ImageBackground>
    </View>
  );
}

const styles = StyleSheet.create({
  titol : {
  fontFamily : 'Poppins',
  fontSize : '1.5rem',
  lineHeight : 32,
  fontWeight : '700',
  fontStyle : 'normal',
  color : "#383738",
  paddingTop:'0.5rem',
  textAlign:'center',
  },
  paragraf : {
  fontFamily: 'Poppins',
  fontSize: '1rem',
  fontWeight: '600',
  fontStyle: 'normal',
  // color: '#898B8E',
  textAlign:'center',
},
// boto : {
//   marginTop: '3rem',
//   padding : "0.2rem 0.4rem",
//   gap : "8px",
//   width : "60%",
//   height : "3rem",
//   justifyContent : "center",
//   alignItems : "center",
//   backgroundColor : "#334960",
//   borderRadius : "8px",
//   fontFamily : 'Poppins',
// },
textBoto : {
fontFamily : 'Poppins',
fontSize : '1rem',
fontWeight : '700',
fontStyle : 'normal',
color: "#F5F7FA",
lineHeight : "120%",
letterSpacing : "0.03em",
textAlign : "center",

},
});